// Production calendar: Monday–Friday, entire days, Venezuela (UTC−04:00).
// Not a work-shift or holiday calendar. Never use it for financial/legal expiries.
const DAY = 86400000;
const WEEK = 7 * DAY;
const WORK_WEEK = 5 * DAY;
const MONDAY = Date.parse('1970-01-05T04:00:00Z');
const milliseconds = value => value === null || value === undefined ? NaN : new Date(value).getTime();
const rank = time => {
  const relative = time - MONDAY, weeks = Math.floor(relative / WEEK);
  return weeks * WORK_WEEK + Math.min(relative - weeks * WEEK, WORK_WEEK);
};

export function businessSecondsBetween(from, to) {
  const start = milliseconds(from), end = milliseconds(to);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return 0;
  return Math.floor((rank(end) - rank(start)) / 1000);
}

export function addBusinessSeconds(from, seconds) {
  const start = milliseconds(from), amount = Number(seconds);
  if (!Number.isFinite(start) || !Number.isFinite(amount)) return new Date(NaN);
  if (amount === 0) return new Date(start); // Keep an explicitly chosen deadline unchanged.
  const target = rank(start) + amount * 1000, weeks = Math.floor(target / WORK_WEEK);
  return new Date(MONDAY + weeks * WEEK + target - weeks * WORK_WEEK);
}

// Preserve the local time of day: a Friday + 5 days is the following Friday.
// Orders created on Saturday/Sunday start counting with Monday as day one.
export function addBusinessDays(from, days) {
  let time = milliseconds(from);
  if (!Number.isFinite(time) || !Number.isSafeInteger(days) || days < 0 || days > 36600) return new Date(NaN);
  while (days > 0) {
    time += DAY;
    const day = new Date(time - 4 * 3600000).getUTCDay();
    if (day !== 0 && day !== 6) days--;
  }
  return new Date(time);
}

export function businessEventDuration(event) {
  const duration = Number(event.duration_seconds);
  if (event.duration_seconds === null || event.duration_seconds === undefined || !Number.isFinite(duration)) return null;
  const end = milliseconds(event.created_at);
  return Math.max(0, businessSecondsBetween(end - Math.max(0, duration) * 1000, end));
}
